"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grade = void 0;
/**
 * Grade representing Great Minds course information.
 *
 * @property {string}           id
 * @property {string}           name
 * @property {string}           description
 *
 * @author javier.perez
 */
var Grade = /** @class */ (function () {
    function Grade(grade) {
        if (grade === void 0) { grade = {}; }
        Object.assign(this, grade);
    }
    Grade.prototype.getModule = function (moduleId) {
        return (this.modules || []).find(function (module) { return module.id === moduleId; });
    };
    Object.defineProperty(Grade.prototype, "hasAssessmentTemplates", {
        get: function () {
            var withAssessmentTemplates = (this.modules || []).filter(function (module) { return module.hasAssessmentTemplates; });
            return withAssessmentTemplates.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Grade.prototype.clone = function () {
        var _a = this, modules = _a.modules, rest = __rest(_a, ["modules"]);
        var cloned = new Grade(__assign(__assign({}, rest), { modules: modules ? modules.map(function (module) { return module.clone(); }) : modules }));
        return cloned;
    };
    return Grade;
}());
exports.Grade = Grade;
